module.exports = __webpack_public_path__ + "static/media/landing-background.ecb98364.jpg";